import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  getPuntosControl,
  juecesEvento,
  resultadosEventoNew,
  eventSubEvents,
  configuracionEvento,
} from "../../../../../data-store/actions/events-actions";

import { Grid, Typography, Divider, Card } from "@material-ui/core";
import PhotoCameraIcon from "@material-ui/icons/PhotoCamera";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import FullScreenDialog from "../../../Modals/FullScreenDialog";
import TimingRegistryContainer from "./TimingRegistryContainer";
import StartsList from "./StartsList";
import PhotoBatchUploaderCamera from "../../PhotosEvent/PhotoBatchUploaderCamera";
import StartClocksView from "./StartClocksView";
import usePuntosControl from "../../../../../services/usePuntosControl";

export default function GetControlPoints({ match }) {
  const { EventoIndex } = match.params;

  const dispatch = useDispatch();
  const userID = useSelector((state) => state.atlete.userID);
  const atleteAccount = useSelector((state) => state.atlete.atleteAccount);

  const eventDetail = useSelector((state) => state.events.eventDetail);
  const eventSubEvents1 = useSelector((state) => state.events.eventSubEvents);
  const eventConfiguration = useSelector(
    (state) => state.events.eventConfiguration
  );
  const puntosControl = usePuntosControl();

  // Esta pantalla es la entrada de "vista de registro" (antes de elegir un
  // punto de control específico) — se adelanta acá la descarga de
  // eventSubEvents/eventConfiguration para que ya estén listas cuando el
  // usuario abra el detalle de un atleta desde un punto de control (sin
  // esto, la sección de subclasificaciones del detalle no se veía hasta
  // visitar la vista de resultados, que sí las carga). Solo se piden si
  // todavía no están en el store.
  useEffect(() => {
    if (!eventSubEvents1) {
      dispatch(eventSubEvents(EventoIndex));
    }
    if (!eventConfiguration) {
      dispatch(configuracionEvento(EventoIndex));
    }
  }, [EventoIndex, eventSubEvents1, eventConfiguration]);

  // Antes esto corría una sola vez (deps []), nunca se repetía al cambiar
  // de evento — como este componente no se desmonta al navegar hacia otro
  // evento (no hay key dinámica en la ruta), puntosControl/jueces/
  // resultados se quedaban con los datos del primer evento que se visitó
  // en la sesión. Ahora se vuelve a pedir cada vez que cambia EventoIndex;
  // las 3 acciones ya cierran el listener del evento anterior antes de
  // abrir el nuevo (ver events-actions.js), así que repetir la carga al
  // volver a un evento ya visitado no deja listeners duplicados.
  useEffect(() => {
    dispatch(getPuntosControl(EventoIndex));
    dispatch(juecesEvento(EventoIndex));
    dispatch(resultadosEventoNew(EventoIndex));
  }, [EventoIndex]);

  if (!eventDetail.cronometrajeDisponible) {
    return <div></div>;
  }

  return (
    <Grid
      container
      direction="row"
      justifyContent="space-evenly"
      alignItems="center"
    >
      <Grid item xs={12} sm={12}>
        <Typography gutterBottom variant={"h5"} align="center">
          Puntos de Control
        </Typography>
      </Grid>
      <Grid item xs={12} sm={12}>
        {puntosControl &&
          Object.values(puntosControl).map((a) => (
            <FullScreenDialog
              buttomLabel={a.descripcionFinalPunto}
              title={a.descripcionFinalPunto}
              report={<TimingRegistryContainer kPuntoControl={a} />}
            />
          ))}
      </Grid>
      {/* Antes era uno de los 6 tabs de "Fotos Evento (Beta)" — se movió
      acá (como botón, no tab) para que quien está en los puntos de control
      la tenga a la vista; esta pantalla completa ya solo se muestra si el
      crono está habilitado para el evento (ver el return vacío arriba). */}
      <Grid item xs={12} sm={12} style={{ marginTop: 24 }}>
        <Divider style={{ marginBottom: 16 }} />
        <Card style={{ padding: 16 }}>
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
          >
            <Grid item>
              <FullScreenDialog
                buttomLabel={
                  <>
                    <PhotoCameraIcon style={{ marginRight: 8 }} />
                    Tomar fotos de Meta
                  </>
                }
                title={"Tomar fotos de Meta"}
                ButtonStyle={{
                  backgroundColor: "#2e7d32",
                  color: "#fff",
                  padding: "10px 24px",
                  borderRadius: 4,
                }}
                report={
                  <PhotoBatchUploaderCamera
                    eventId={EventoIndex}
                    userId={userID}
                  />
                }
              />
            </Grid>
            {/* Call to action: réplica (sin Bluetooth del reloj físico) de
            la vista de cronómetros de salida de la app móvil — inicia/
            reinicia/sincroniza la hora de salida de una o varias series a
            la vez. Se destaca a la derecha con el color primario. */}
            <Grid item>
              <FullScreenDialog
                buttomLabel={
                  <>
                    <AccessTimeIcon style={{ marginRight: 8 }} />
                    Relojes
                  </>
                }
                title={"Cronos / Relojes"}
                ButtonStyle={{
                  backgroundColor: "#ff4400",
                  color: "#fff",
                  padding: "12px 28px",
                  borderRadius: 24,
                  fontWeight: 700,
                }}
                report={<StartClocksView eventoIndex={EventoIndex} />}
              />
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );
}
